module.exports = __webpack_public_path__ + "img/3_bg_noatm.314d00da.png";